import { APP_CONFIG } from "../constants";
import { AppError } from "../utils/errorHandler";

export type BordaEmFaltaItem = {
  id: number;
  lojaId: number;
  lojaNome: string;
  bordaNome: string;
  filaSalgadaId: number | null;
  filaDoceId: number | null;
  filaSalaoSalgadaId: number | null;
  filaSalaoDoceId: number | null;
  createdAt: string;
};

export type AguardandoBordaOrfaoItem = {
  lojaId: number;
  lojaNome: string;
  tipo: "salgada" | "doce" | "salao_salgada" | "salao_doce";
  filaId: number;
  displayId: number;
  orderId: number;
  bordaNome: string;
  canal: "cardapio" | "salao";
  createdAt: string;
  dia: string;
};

export type LiberarBordasResult = {
  ok: boolean;
  lojaId: number;
  bordasEmFaltaRemovidas: number;
  filasSalgadaLiberadas: number;
  filasDoceLiberadas: number;
  filasSalaoSalgadaLiberadas: number;
  filasSalaoDoceLiberadas: number;
};

export type OrfaoAcaoModo = "voltar_fila" | "limpar";

export type LiberarOrfaosResult = {
  ok: boolean;
  lojaId: number;
  data: string;
  modo: OrfaoAcaoModo;
  filasSalgadaLiberadas: number;
  filasDoceLiberadas: number;
  filasSalaoSalgadaLiberadas: number;
  filasSalaoDoceLiberadas: number;
  totalLiberadas: number;
};

export type PedidoControleCanal = "cardapio" | "salao";

export type PedidoControleAcao = "avancar" | "voltar" | "cancelar" | "reabrir";

export type PedidoControleItemTipo =
  | "fila_salgada"
  | "fila_doce"
  | "fila_salao_salgada"
  | "fila_salao_doce"
  | "forno"
  | "fila_porcao"
  | "fila_bebida"
  | "paozinho_preparo"
  | "fila_aguardando_entrega";

export type PedidoControleBuscaItem = {
  canal: PedidoControleCanal;
  pedidoIntegracaoId: number | null;
  pedidoFoodflyId: number | null;
  lojaId: number;
  lojaNome: string;
  displayId: number;
  orderId: number;
  customerName: string | null;
  salaoIdentificador: string | null;
  statusIntegracao: string | null;
  chegouEm: string;
};

export type PedidoControleAcaoDisponivel = {
  acao: PedidoControleAcao;
  label: string;
  descricao: string;
};

export type PedidoControleItem = {
  tipo: PedidoControleItemTipo;
  id: number;
  label: string;
  status: string;
  displayId: number;
  orderId: number;
  lojaId: number;
  acoes: PedidoControleAcaoDisponivel[];
};

export type PedidoControleDetalhe = {
  canal: PedidoControleCanal;
  pedidoIntegracaoId: number | null;
  pedidoFoodflyId: number | null;
  lojaId: number;
  lojaNome: string;
  displayId: number;
  orderId: number;
  customerName: string | null;
  salaoIdentificador: string | null;
  salaoMesaId: string | null;
  salaoComandaId: string | null;
  orderType: string | null;
  statusIntegracao: string | null;
  status: string | null;
  chegouEm: string;
  itens: PedidoControleItem[];
  payloadOriginal?: unknown;
};

export type SaborMapeamentoItem = {
  id: number;
  nomeOrigem: string;
  chave: string;
  canalDoce: boolean;
  cardapioId: number;
  cardapioNome: string;
  ativo: boolean;
  observacao: string | null;
  createdAt: string;
  updatedAt: string;
};

export type SaborAliasCodigoItem = {
  chave: string;
  canalDoce: boolean;
  nomeCanonico: string;
  fonte: "codigo";
  arquivo: string;
  nomeExemplo: string;
  cardapioId: number | null;
  cardapioNome: string | null;
  resolucaoFonte: SaborSimulacaoItem["fonte"];
};

export type SaborExemploSemAliasItem = SaborSimulacaoItem & {
  cardapiosSimilares: CardapioResumo[];
};

export type CardapioResumo = {
  id: number;
  nome: string;
};

export type SaborCatalogoCodigoResponse = {
  itens: SaborAliasCodigoItem[];
  exemplosSemAlias: SaborExemploSemAliasItem[];
};

export type SaborPendenteItem = {
  nomeOrigem: string;
  chave: string;
  canalDoce: boolean;
  origem: "cardapio_web" | "foodfly";
  ocorrencias: number;
};

export type SaborSimulacaoItem = {
  nomeOrigem: string;
  chave: string;
  canalDoce: boolean;
  cardapioId: number | null;
  cardapioNome: string | null;
  fonte: "banco" | "codigo_alias" | "match_automatico" | "sem_match";
};

export type CardapioSaborOption = {
  id: number;
  nome: string;
  tipo: string;
};

export type FoodflyProdutoTipo =
  | "bebida"
  | "porcao"
  | "pizza"
  | "paozinho"
  | "ignorar";

export type ProdutoMapeamentoItem = {
  id: number;
  nomeOrigem: string;
  chave: string;
  tipo: FoodflyProdutoTipo;
  ativo: boolean;
  observacao: string | null;
  createdAt: string;
  updatedAt: string;
};

export type ProdutoCodigoItem = {
  nomeOrigem: string;
  chave: string;
  tipo: FoodflyProdutoTipo;
  fonte: "codigo";
};

export type ProdutoPendenteItem = {
  nomeOrigem: string;
  chave: string;
  ocorrencias: number;
  origem: "foodfly" | "cardapio_web" | "ambos";
};

export type ProdutoSimulacaoItem = {
  nomeOrigem: string;
  chave: string;
  tipo: FoodflyProdutoTipo | null;
  fonte: "banco" | "codigo" | "sem_match";
};

export type FichaDiariaDevAssinaturaTipo =
  | "conferencia"
  | "producao"
  | "producao_total"
  | "todas";

export type FichaDiariaDevUnd = {
  id: number;
  nome: string;
};

export type FichaDiariaDevAssinaturaSetor = {
  setorId: number;
  setorNome: string;
  assinado: boolean;
  liberadoDev?: boolean;
  userId: number | null;
  userNome: string | null;
  dataAssinatura: string | null;
  motivos?: string[];
};

export type FichaDiariaDevProducaoSetor = {
  setorId: number;
  setorNome: string;
  producao: string | null;
  undMedidaIdProducao: number | null;
  producaoChecada: boolean;
  naoProduzidoPelaUnidade: boolean;
  justificativaNaoProduziu: string | null;
  observacaoProducao: string | null;
};

export type FichaDiariaDevItem = {
  itemId: number;
  descricao: string;
  origemProducao: string;
  ativo: boolean;
  ordem: number;
  diario: {
    sobra: string | null;
    undMedidaIdSobra: number | null;
    producao: string | null;
    undMedidaIdProducao: number | null;
    producaoChecada: boolean;
    naoProduzidoPelaUnidade: boolean;
    justificativaNaoProduziu: string | null;
    observacaoSobra: string | null;
    observacaoProducao: string | null;
  };
  producaoPorSetor: FichaDiariaDevProducaoSetor[];
};

export type FichaDiariaDevCronometroAcao =
  | "pausar"
  | "retomar"
  | "reabrir"
  | "encerrar"
  | "ajustar"
  | "zerar";

export type FichaDiariaDevCronometro = {
  id: number;
  itemId: number;
  itemDescricao: string;
  setorId: number;
  setorNome: string;
  userId: number;
  userNome: string | null;
  status: "RUNNING" | "PAUSED" | "FINISHED" | string;
  startedAt: string | null;
  pausedAt: string | null;
  finishedAt: string | null;
  runningSince: string | null;
  tempoLiquidoMs: number;
  tempoFormatado: string;
  tempoPausaManualMs: number;
  tempoPausaFormatado: string;
  pausaAutomatica: boolean;
};

export type FichaDiariaDevDetalhe = {
  lojaId: number;
  lojaNome: string;
  dataFicha: string;
  ficha: {
    id: number;
    assinadoConfere: boolean;
    userConfereId: number | null;
    userConfereNome: string | null;
    dataAssinaturaConf: string | null;
    justificativaSemSobra: string | null;
    assinadoProducao: boolean;
    userProducaoId: number | null;
    userProducaoNome: string | null;
    dataAssinaturaProducao: string | null;
    ajustadoAdminConferencia: boolean;
    ajustadoAdminProducao: boolean;
    liberadoDevConferencia?: boolean;
    liberadoDevProducao?: boolean;
    edicaoLiberadaAtiva?: boolean;
    edicaoLiberadaAte?: string | null;
    edicaoLiberadaPorNome?: string | null;
  } | null;
  bloqueiosConferencia?: string[];
  bloqueiosProducaoTotal?: string[];
  assinaturasSetores: FichaDiariaDevAssinaturaSetor[];
  unds: FichaDiariaDevUnd[];
  itens: FichaDiariaDevItem[];
  cronometragens?: FichaDiariaDevCronometro[];
  edicaoLiberadaLojaAtiva?: boolean;
  edicaoLiberadaLojaAte?: string | null;
  edicaoLiberadaLojaPorNome?: string | null;
};

export type FichaDiariaDevRecente = {
  id: number;
  dataFicha: string;
  assinadoConfere: boolean;
  assinadoProducao: boolean;
  setoresAssinados: number;
  setoresTotal: number;
};

export type FichaDiariaDevLinhaInput = {
  itemId: number;
  sobra?: string | null;
  undMedidaIdSobra?: number | null;
  producao?: string | null;
  undMedidaIdProducao?: number | null;
  producaoChecada?: boolean;
  naoProduzidoPelaUnidade?: boolean;
  justificativaNaoProduziu?: string | null;
  observacaoSobra?: string | null;
  observacaoProducao?: string | null;
  setores?: FichaDiariaDevProducaoSetor[];
};

async function parseError(response: Response): Promise<never> {
  try {
    const data = (await response.json()) as { message?: string | string[] };
    const msg = Array.isArray(data.message)
      ? data.message[0]
      : data.message || response.statusText;
    throw new AppError(msg, response.status);
  } catch (e) {
    if (e instanceof AppError) throw e;
    throw new AppError(response.statusText, response.status);
  }
}

function authHeaders(json = false): HeadersInit {
  const headers: Record<string, string> = {
    Authorization: `Bearer ${localStorage.getItem("token") ?? ""}`,
    Accept: "application/json",
  };
  if (json) headers["Content-Type"] = "application/json";
  return headers;
}

export const desenvolvedorService = {
  listarBordasEmFalta: async (
    lojaId?: number,
  ): Promise<BordaEmFaltaItem[]> => {
    const q =
      lojaId != null ? `?lojaId=${encodeURIComponent(String(lojaId))}` : "";
    const res = await fetch(
      `${APP_CONFIG.API_URL}/desenvolvedor/producao/bordas-em-falta${q}`,
      { headers: authHeaders() },
    );
    if (!res.ok) return parseError(res);
    const data = (await res.json()) as { itens: BordaEmFaltaItem[] };
    return data.itens ?? [];
  },

  listarAguardandoBordaOrfaos: async (
    lojaId?: number,
  ): Promise<AguardandoBordaOrfaoItem[]> => {
    const q =
      lojaId != null ? `?lojaId=${encodeURIComponent(String(lojaId))}` : "";
    const res = await fetch(
      `${APP_CONFIG.API_URL}/desenvolvedor/producao/aguardando-borda-orfaos${q}`,
      { headers: authHeaders() },
    );
    if (!res.ok) return parseError(res);
    const data = (await res.json()) as { itens: AguardandoBordaOrfaoItem[] };
    return data.itens ?? [];
  },

  liberarBordasEmFalta: async (lojaId: number): Promise<LiberarBordasResult> => {
    const res = await fetch(
      `${APP_CONFIG.API_URL}/desenvolvedor/producao/liberar-bordas-em-falta`,
      {
        method: "POST",
        headers: authHeaders(true),
        body: JSON.stringify({ lojaId, confirmacao: true }),
      },
    );
    if (!res.ok) return parseError(res);
    return (await res.json()) as LiberarBordasResult;
  },

  liberarAguardandoBordaOrfaos: async (params: {
    lojaId: number;
    data: string;
    modo: OrfaoAcaoModo;
  }): Promise<LiberarOrfaosResult> => {
    const res = await fetch(
      `${APP_CONFIG.API_URL}/desenvolvedor/producao/liberar-aguardando-borda-orfaos`,
      {
        method: "POST",
        headers: authHeaders(true),
        body: JSON.stringify({
          lojaId: params.lojaId,
          data: params.data,
          modo: params.modo,
          confirmacao: true,
        }),
      },
    );
    if (!res.ok) return parseError(res);
    return (await res.json()) as LiberarOrfaosResult;
  },

  buscarPedidos: async (params: {
    lojaId: number;
    displayId?: number;
    orderId?: number;
    canal?: PedidoControleCanal | "";
  }): Promise<PedidoControleBuscaItem[]> => {
    const q = new URLSearchParams();
    q.set("lojaId", String(params.lojaId));
    if (params.displayId != null) q.set("displayId", String(params.displayId));
    if (params.orderId != null) q.set("orderId", String(params.orderId));
    if (params.canal) q.set("canal", params.canal);
    const res = await fetch(
      `${APP_CONFIG.API_URL}/desenvolvedor/pedidos/buscar?${q.toString()}`,
      { headers: authHeaders() },
    );
    if (!res.ok) return parseError(res);
    const data = (await res.json()) as { resultados: PedidoControleBuscaItem[] };
    return data.resultados ?? [];
  },

  detalharPedido: async (params: {
    canal: PedidoControleCanal;
    pedidoIntegracaoId?: number | null;
    pedidoFoodflyId?: number | null;
  }): Promise<PedidoControleDetalhe> => {
    const q = new URLSearchParams();
    q.set("canal", params.canal);
    if (params.pedidoIntegracaoId != null) {
      q.set("pedidoIntegracaoId", String(params.pedidoIntegracaoId));
    }
    if (params.pedidoFoodflyId != null) {
      q.set("pedidoFoodflyId", String(params.pedidoFoodflyId));
    }
    const res = await fetch(
      `${APP_CONFIG.API_URL}/desenvolvedor/pedidos/detalhe?${q.toString()}`,
      { headers: authHeaders() },
    );
    if (!res.ok) return parseError(res);
    return (await res.json()) as PedidoControleDetalhe;
  },

  moverItem: async (body: {
    tipo: PedidoControleItemTipo;
    id: number;
    acao: PedidoControleAcao;
    confirmacao: boolean;
  }): Promise<{
    ok: boolean;
    message: string;
    detalhe?: PedidoControleDetalhe;
  }> => {
    const res = await fetch(
      `${APP_CONFIG.API_URL}/desenvolvedor/pedidos/mover-item`,
      {
        method: "POST",
        headers: authHeaders(true),
        body: JSON.stringify(body),
      },
    );
    if (!res.ok) return parseError(res);
    return (await res.json()) as {
      ok: boolean;
      message: string;
      detalhe?: PedidoControleDetalhe;
    };
  },

  listarMapeamentosSabores: async (apenasAtivos = false): Promise<SaborMapeamentoItem[]> => {
    const q = apenasAtivos ? "?apenasAtivos=1" : "";
    const res = await fetch(
      `${APP_CONFIG.API_URL}/desenvolvedor/mapeamento/sabores${q}`,
      { headers: authHeaders() },
    );
    if (!res.ok) return parseError(res);
    const data = (await res.json()) as { itens: SaborMapeamentoItem[] };
    return data.itens ?? [];
  },

  listarAliasesCodigoSabores: async (): Promise<SaborCatalogoCodigoResponse> => {
    const res = await fetch(
      `${APP_CONFIG.API_URL}/desenvolvedor/mapeamento/sabores/aliases-codigo`,
      { headers: authHeaders() },
    );
    if (!res.ok) return parseError(res);
    return (await res.json()) as SaborCatalogoCodigoResponse;
  },

  listarCardapiosMapeamento: async (): Promise<CardapioSaborOption[]> => {
    const res = await fetch(
      `${APP_CONFIG.API_URL}/desenvolvedor/mapeamento/sabores/cardapios`,
      { headers: authHeaders() },
    );
    if (!res.ok) return parseError(res);
    const data = (await res.json()) as { itens: CardapioSaborOption[] };
    return data.itens ?? [];
  },

  listarSaboresPendentes: async (dias = 7): Promise<SaborPendenteItem[]> => {
    const res = await fetch(
      `${APP_CONFIG.API_URL}/desenvolvedor/mapeamento/sabores/pendentes?dias=${encodeURIComponent(String(dias))}`,
      { headers: authHeaders() },
    );
    if (!res.ok) return parseError(res);
    const data = (await res.json()) as { itens: SaborPendenteItem[] };
    return data.itens ?? [];
  },

  simularMapeamentoSabores: async (
    nomes: string[],
  ): Promise<SaborSimulacaoItem[]> => {
    const res = await fetch(
      `${APP_CONFIG.API_URL}/desenvolvedor/mapeamento/sabores/simular`,
      {
        method: "POST",
        headers: authHeaders(true),
        body: JSON.stringify({ nomes }),
      },
    );
    if (!res.ok) return parseError(res);
    const data = (await res.json()) as { itens: SaborSimulacaoItem[] };
    return data.itens ?? [];
  },

  criarMapeamentoSabor: async (body: {
    nomeOrigem: string;
    cardapioId: number;
    canalDoce?: boolean;
    observacao?: string;
  }): Promise<SaborMapeamentoItem> => {
    const res = await fetch(
      `${APP_CONFIG.API_URL}/desenvolvedor/mapeamento/sabores`,
      {
        method: "POST",
        headers: authHeaders(true),
        body: JSON.stringify(body),
      },
    );
    if (!res.ok) return parseError(res);
    const data = (await res.json()) as { item: SaborMapeamentoItem };
    return data.item;
  },

  atualizarMapeamentoSabor: async (
    id: number,
    body: {
      nomeOrigem?: string;
      cardapioId?: number;
      ativo?: boolean;
      observacao?: string | null;
    },
  ): Promise<SaborMapeamentoItem> => {
    const res = await fetch(
      `${APP_CONFIG.API_URL}/desenvolvedor/mapeamento/sabores/${id}`,
      {
        method: "PATCH",
        headers: authHeaders(true),
        body: JSON.stringify(body),
      },
    );
    if (!res.ok) return parseError(res);
    const data = (await res.json()) as { item: SaborMapeamentoItem };
    return data.item;
  },

  listarMapeamentosProdutos: async (
    apenasAtivos = false,
  ): Promise<ProdutoMapeamentoItem[]> => {
    const q = apenasAtivos ? "?apenasAtivos=1" : "";
    const res = await fetch(
      `${APP_CONFIG.API_URL}/desenvolvedor/mapeamento/produtos${q}`,
      { headers: authHeaders() },
    );
    if (!res.ok) return parseError(res);
    const data = (await res.json()) as { itens: ProdutoMapeamentoItem[] };
    return data.itens ?? [];
  },

  listarCatalogoCodigoProdutos: async (): Promise<{
    bebidas: ProdutoCodigoItem[];
  }> => {
    const res = await fetch(
      `${APP_CONFIG.API_URL}/desenvolvedor/mapeamento/produtos/catalogo-codigo`,
      { headers: authHeaders() },
    );
    if (!res.ok) return parseError(res);
    return (await res.json()) as { bebidas: ProdutoCodigoItem[] };
  },

  listarProdutosPendentes: async (
    dias = 7,
  ): Promise<ProdutoPendenteItem[]> => {
    const res = await fetch(
      `${APP_CONFIG.API_URL}/desenvolvedor/mapeamento/produtos/pendentes?dias=${encodeURIComponent(String(dias))}`,
      { headers: authHeaders() },
    );
    if (!res.ok) return parseError(res);
    const data = (await res.json()) as { itens: ProdutoPendenteItem[] };
    return data.itens ?? [];
  },

  simularMapeamentoProdutos: async (
    nomes: string[],
  ): Promise<ProdutoSimulacaoItem[]> => {
    const res = await fetch(
      `${APP_CONFIG.API_URL}/desenvolvedor/mapeamento/produtos/simular`,
      {
        method: "POST",
        headers: authHeaders(true),
        body: JSON.stringify({ nomes }),
      },
    );
    if (!res.ok) return parseError(res);
    const data = (await res.json()) as { itens: ProdutoSimulacaoItem[] };
    return data.itens ?? [];
  },

  criarMapeamentoProduto: async (body: {
    nomeOrigem: string;
    tipo: FoodflyProdutoTipo;
    observacao?: string;
  }): Promise<ProdutoMapeamentoItem> => {
    const res = await fetch(
      `${APP_CONFIG.API_URL}/desenvolvedor/mapeamento/produtos`,
      {
        method: "POST",
        headers: authHeaders(true),
        body: JSON.stringify(body),
      },
    );
    if (!res.ok) return parseError(res);
    const data = (await res.json()) as { item: ProdutoMapeamentoItem };
    return data.item;
  },

  atualizarMapeamentoProduto: async (
    id: number,
    body: {
      nomeOrigem?: string;
      tipo?: FoodflyProdutoTipo;
      ativo?: boolean;
      observacao?: string | null;
    },
  ): Promise<ProdutoMapeamentoItem> => {
    const res = await fetch(
      `${APP_CONFIG.API_URL}/desenvolvedor/mapeamento/produtos/${id}`,
      {
        method: "PATCH",
        headers: authHeaders(true),
        body: JSON.stringify(body),
      },
    );
    if (!res.ok) return parseError(res);
    const data = (await res.json()) as { item: ProdutoMapeamentoItem };
    return data.item;
  },

  obterFichaDiaria: async (params: {
    lojaId: number;
    data: string;
  }): Promise<FichaDiariaDevDetalhe> => {
    const q = new URLSearchParams();
    q.set("lojaId", String(params.lojaId));
    q.set("data", params.data);
    const res = await fetch(
      `${APP_CONFIG.API_URL}/desenvolvedor/ficha-diaria?${q.toString()}`,
      { headers: authHeaders() },
    );
    if (!res.ok) return parseError(res);
    return (await res.json()) as FichaDiariaDevDetalhe;
  },

  listarFichasDiariasRecentes: async (params: {
    lojaId: number;
    limite?: number;
  }): Promise<{
    lojaId: number;
    lojaNome: string;
    fichas: FichaDiariaDevRecente[];
  }> => {
    const q = new URLSearchParams();
    q.set("lojaId", String(params.lojaId));
    if (params.limite != null) q.set("limite", String(params.limite));
    const res = await fetch(
      `${APP_CONFIG.API_URL}/desenvolvedor/ficha-diaria/recentes?${q.toString()}`,
      { headers: authHeaders() },
    );
    if (!res.ok) return parseError(res);
    return (await res.json()) as {
      lojaId: number;
      lojaNome: string;
      fichas: FichaDiariaDevRecente[];
    };
  },

  desmarcarAssinaturasFichaDiaria: async (body: {
    lojaId: number;
    data: string;
    tipo: FichaDiariaDevAssinaturaTipo;
    setorId?: number;
    confirmacao: boolean;
  }): Promise<{
    ok: boolean;
    message: string;
    detalhe: FichaDiariaDevDetalhe;
  }> => {
    const res = await fetch(
      `${APP_CONFIG.API_URL}/desenvolvedor/ficha-diaria/desmarcar-assinaturas`,
      {
        method: "POST",
        headers: authHeaders(true),
        body: JSON.stringify(body),
      },
    );
    if (!res.ok) return parseError(res);
    return (await res.json()) as {
      ok: boolean;
      message: string;
      detalhe: FichaDiariaDevDetalhe;
    };
  },

  liberarAssinaturasFichaDiaria: async (body: {
    lojaId: number;
    data: string;
    tipo: FichaDiariaDevAssinaturaTipo;
    setorId?: number;
    confirmacao: boolean;
  }): Promise<{
    ok: boolean;
    message: string;
    detalhe: FichaDiariaDevDetalhe;
  }> => {
    const res = await fetch(
      `${APP_CONFIG.API_URL}/desenvolvedor/ficha-diaria/liberar-assinaturas`,
      {
        method: "POST",
        headers: authHeaders(true),
        body: JSON.stringify(body),
      },
    );
    if (!res.ok) return parseError(res);
    return (await res.json()) as {
      ok: boolean;
      message: string;
      detalhe: FichaDiariaDevDetalhe;
    };
  },

  liberarEdicaoFichaDiaria: async (body: {
    lojaId: number;
    data?: string;
    duracaoHoras?: number;
    confirmacao: boolean;
  }): Promise<{
    ok: boolean;
    message: string;
    detalhe: FichaDiariaDevDetalhe;
  }> => {
    const res = await fetch(
      `${APP_CONFIG.API_URL}/desenvolvedor/ficha-diaria/liberar-edicao`,
      {
        method: "POST",
        headers: authHeaders(true),
        body: JSON.stringify(body),
      },
    );
    if (!res.ok) return parseError(res);
    return (await res.json()) as {
      ok: boolean;
      message: string;
      detalhe: FichaDiariaDevDetalhe;
    };
  },

  forcarAssinaturasFichaDiaria: async (body: {
    lojaId: number;
    data: string;
    tipo: FichaDiariaDevAssinaturaTipo;
    setorId?: number;
    confirmacao: boolean;
  }): Promise<{
    ok: boolean;
    message: string;
    detalhe: FichaDiariaDevDetalhe;
  }> => {
    const res = await fetch(
      `${APP_CONFIG.API_URL}/desenvolvedor/ficha-diaria/forcar-assinaturas`,
      {
        method: "POST",
        headers: authHeaders(true),
        body: JSON.stringify(body),
      },
    );
    if (!res.ok) return parseError(res);
    return (await res.json()) as {
      ok: boolean;
      message: string;
      detalhe: FichaDiariaDevDetalhe;
    };
  },

  acionarCronometroFichaDiaria: async (body: {
    lojaId: number;
    data: string;
    cronometragemId: number;
    acao: FichaDiariaDevCronometroAcao;
    tempoLiquidoMs?: number;
    confirmacao: boolean;
  }): Promise<{
    ok: boolean;
    message: string;
    detalhe: FichaDiariaDevDetalhe;
  }> => {
    const res = await fetch(
      `${APP_CONFIG.API_URL}/desenvolvedor/ficha-diaria/cronometro`,
      {
        method: "POST",
        headers: authHeaders(true),
        body: JSON.stringify(body),
      },
    );
    if (!res.ok) return parseError(res);
    return (await res.json()) as {
      ok: boolean;
      message: string;
      detalhe: FichaDiariaDevDetalhe;
    };
  },

  salvarApontamentosFichaDiaria: async (body: {
    lojaId: number;
    data: string;
    justificativaSemSobra?: string | null;
    linhas: FichaDiariaDevLinhaInput[];
  }): Promise<{
    ok: boolean;
    message: string;
    detalhe: FichaDiariaDevDetalhe;
  }> => {
    const res = await fetch(
      `${APP_CONFIG.API_URL}/desenvolvedor/ficha-diaria/apontamentos`,
      {
        method: "POST",
        headers: authHeaders(true),
        body: JSON.stringify(body),
      },
    );
    if (!res.ok) return parseError(res);
    return (await res.json()) as {
      ok: boolean;
      message: string;
      detalhe: FichaDiariaDevDetalhe;
    };
  },
};
